import React, {Component} from 'react';
import Autosuggest, { ItemAdapter } from '../../modules/autosuggest/Autosuggest.js'
import Config from '../../config';

class AutoAdapter extends ItemAdapter {
 renderItem(item) {
  return (
   <div>
    <div className="repo-title">{item.name}</div>
    <div className="repo-stats">{ parseFloat(item.price).toFixed(2) }€&nbsp;&nbsp;&nbsp;<strong>{item.stock} en stock</strong></div>
   </div>
  )
 }
}

AutoAdapter.instance = new AutoAdapter();

class ProductSearch extends Component {
 constructor(props) {
  super(props);

  this.doChange = this.doChange.bind(this);
  this.doSearch = this.doSearch.bind(this);
  this.doSelect = this.doSelect.bind(this);

  this.state = {
   searchValue: '',
   searchResults: []
  }
 }

 doSearch(search) {
  if(search !== '') {
   this.props.reqAPI(Config.apiURI+'/api/products/barcode/'+search).then(item => {
    if(item.length > 0 && item[0].ID > 0) {
     this.props.handleCallback(item[0]);
     this.setState({ searchValue: '', searchResults: null });
    } else if (search) {
     const sp = search.lastIndexOf('/');
     if (sp >= 0) search = search.substring(sp + 1);
     this.props.reqAPI(Config.apiURI+'/api/products/search?words='+encodeURIComponent(search)).then(searchResults => {
      this.setState({ searchResults });
     }, err => {
      this.setState({ searchResults: null });
     })
    } else {
     this.setState({ searchResults: null }, () => {
      this.inputElement.refs.input.focus();
     });
    }
   })

   this.inputElement.refs.input.focus();
  }
 }

 doChange(value) {
  this.setState({searchValue:value})
 }

 doSelect(item) {
  if(item !== null && item.ID !== undefined) {
   this.props.handleCallback(item);
   this.setState({
    searchValue: '',
    searchResults: []
   });
  }
 }

 doToogle() {
  this.inputElement.refs.input.focus();
 }

 componentDidMount() {
  this.props.handleInputEL(this.inputElement.refs.input);
 }

 render() {
  return (
   <Autosuggest
    ref={(input) => { this.inputElement = input; }}
    value={this.state.searchValue}
    showToggle={false}
    allowDuplicates={false}
    closeOnCompletion={true}
    datalist={this.state.searchResults}
    datalistOnly={false}
    datalistPartial={false}
    itemReactKeyPropName="ID"
    itemValuePropName="name"
    placeholder={this.props.placeholder ? this.props.placeholder : "Busca aquí un producto o pasalo por el escaner"}
    onSearch={this.doSearch}
    onChange={this.doChange}
    onSelect={this.doSelect}
    itemAdapter={AutoAdapter.instance} />
  )
 }
}

export default ProductSearch;



// WEBPACK FOOTER //
// ./src/components/Product/Search.js